import React from 'react';

// Small things shared by the staff-mode screens (Figma "Staff check-in"): formats, icons and the progress bar.
export const time = (d) => new Date(d).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
export const longDay = (d) => new Date(d).toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
export const shortDay = (d) => new Date(d).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' }).replace(',', '');
export const shortDate = (d) => new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
export const initialsOf = (name) => (name || '?').split(/\s+/).map((w) => w[0]).slice(0, 2).join('').toUpperCase();
export const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;
export const typesOf = (tickets) => [...new Set(tickets.map((t) => t.ticketType).filter(Boolean))].join(', ');
export const MIN_SEARCH = 2; // the server asks for at least 2 characters
// a path plus the manual-check-in search, so going back to the list keeps what was typed
export const withSearch = (path, q) => (q ? `${path}?q=${encodeURIComponent(q)}` : path);

const Svg = ({ children, ...rest }) => <svg viewBox="0 0 24 24" aria-hidden="true" {...rest}>{children}</svg>;
export const ChevronDown = () => <Svg><path d="M6 9l6 6 6-6" /></Svg>;
export const BackIcon = () => <Svg><path d="M15 5l-7 7 7 7" /></Svg>;
export const ExitIcon = () => <Svg><path d="M9 4H5v16h4M16 8l4 4-4 4M20 12H9" /></Svg>;
export const InfoIcon = () => <Svg><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></Svg>;
export const PeopleIcon = () => <Svg><circle cx="9" cy="8" r="3.2" /><path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5M16 5.2a3.2 3.2 0 010 5.6M21 20c0-2.6-1.6-4.4-4-5.2" /></Svg>;
export const BoltIcon = () => <Svg><path d="M13 3L5 14h6l-1 7 8-11h-6z" /></Svg>;
export const KeyboardIcon = () => <Svg><rect x="3" y="6" width="18" height="12" rx="2" /><path d="M7 10h.01M11 10h.01M15 10h.01M7 14h10" /></Svg>;
export const SearchIcon = () => <Svg><circle cx="11" cy="11" r="6.5" /><path d="M20 20l-4.2-4.2" /></Svg>;

export function Progress({ counts }) {
  const pct = counts.total ? Math.round((counts.checkedIn / counts.total) * 1000) / 10 : 0;
  return (
    <div className="sm-progress">
      <div className="sm-bar-track"><i style={{ width: `${pct}%` }} /></div>
      <div className="sm-progress-text"><span>{counts.checkedIn} of {counts.total} checked in</span><em>{pct}% of capacity</em></div>
    </div>
  );
}
